// Apple OAuth (Sign in with Apple) Configuration
// NOTE: Apple typically expects server-side validation of the `id_token`.
// This frontend flow requests an `id_token` and passes it to the backend via `socialLogin`.

export const APPLE_OAUTH_CONFIG = {
  // Apple "Service ID" (for web) from Apple Developer > Certificates, Identifiers & Profiles
  clientId: process.env.REACT_APP_APPLE_CLIENT_ID || 'your-apple-client-id-here',

  // Apple only reliably returns name/email on the FIRST authorization.
  scope: 'name email',

  // Redirect URI must be registered on Apple Developer portal for the Service ID
  redirectUri: `${window.location.origin}${process.env.PUBLIC_URL}/apple-oauth-callback.html`,
};

export const APPLE_OAUTH_ENDPOINTS = {
  authorization: 'https://appleid.apple.com/auth/authorize',
};

const generateRandomString = (length = 32): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const arr = new Uint8Array(length);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, (n) => chars[n % chars.length]).join('');
};

export const validateAppleOAuthConfig = (): boolean => {
  return !!(APPLE_OAUTH_CONFIG.clientId && APPLE_OAUTH_CONFIG.clientId !== 'your-apple-client-id-here');
};

// Generates the Apple authorization URL for a popup-based flow.
// We request an authorization code and return it via query string so the static callback page can read it.
export const generateAppleOAuthPopupUrl = (): { url: string; state: string; nonce: string } => {
  if (!validateAppleOAuthConfig()) {
    throw new Error(
      'Apple OAuth is not configured. Please set REACT_APP_APPLE_CLIENT_ID in your .env file.'
    );
  }

  const state = generateRandomString(32);
  const nonce = generateRandomString(32);

  const params = new URLSearchParams({
    client_id: APPLE_OAUTH_CONFIG.clientId,
    redirect_uri: APPLE_OAUTH_CONFIG.redirectUri,
    response_type: 'code id_token',
    response_mode: 'fragment', // REQUIRED
    // scope: APPLE_OAUTH_CONFIG.scope,
    state,
    nonce,
    });

  return { url: `${APPLE_OAUTH_ENDPOINTS.authorization}?${params.toString()}`, state, nonce };
};


